export const UNAUTHENTICATED_OPTIMIZELY_USER = "unauthenticated_user";

export const OPTIMIZELY_REFRESH_INTERVAL = 180000; // 3 min